import React, { useEffect, useState } from "react";
import { TbChevronLeft, TbChevronRight } from "react-icons/tb";

export default function SpringMoneyPagination(props: any) {

    const [pageNoArray, setPageNoArray] = useState<any>();
    const [lengthOfPageNoArray, setLengthOfPageNoArray] = useState<number>(10);
    const [showPreviousPage, setShowPreviousPage] = useState<boolean>(false);
    const [showNextPage, setShowNextPage] = useState<boolean>(false);
    const [showFastPreviousPage, setShowFastPreviousPage] = useState<boolean>(false);
    const [showFastNextPage, setShowFastNextPage] = useState<boolean>(false);

    useEffect(() => {
        if (props.totalItems % props.itemsCountPerPage !== 0) {
            props.setTotalPages(Math.floor(props.totalItems / props.itemsCountPerPage) + 1)
        } else {
            props.setTotalPages(props.totalItems / props.itemsCountPerPage);
        }
    }, [props.itemsCountPerPage, props.totalItems])

    useEffect(() => {
        updatePageNoArray();
    }, [props.TotalPages, props.currentPageNo])

    const updatePageNoArray = () => {
        let firstPage: number = 0;
        let lastPage: number = 0;

        firstPage = (Math.floor((props.currentPageNo - 1) / lengthOfPageNoArray) * lengthOfPageNoArray) + 1;
        lastPage = firstPage + lengthOfPageNoArray - 1;

        if (props.TotalPages && lastPage > props.TotalPages) {
            lastPage = props.TotalPages;
        }

        let newPageNoArray = [];
        for (let i = firstPage; i <= lastPage; i++) {
            newPageNoArray.push(i);
        }

        setPageNoArray(newPageNoArray);

        if(props.TotalPages){
            setShowFastNextPage(lastPage < props.TotalPages);
        setShowNextPage(props.currentPageNo < props.TotalPages);
        setShowFastPreviousPage(firstPage > 1);
        setShowPreviousPage(props.currentPageNo > 1);
        }
    }


    const previousPage = () => {
        if (props.currentPageNo > 1) {
            props.setCurrentPageNo(props.currentPageNo - 1);
        }
    }

    const nextPage = () => {
        if (props.TotalPages && props.currentPageNo < props.TotalPages) {
            props.setCurrentPageNo(props.currentPageNo + 1);
        }
    }

    const selectPage = (pageNo: number) => {
        props.setCurrentPageNo(pageNo);
    }

    const fastPreviousPage = () => {
        if (props.currentPageNo > 1) {
            props.setCurrentPageNo(Math.max(1, props.currentPageNo - ((props.currentPageNo - pageNoArray[0])+1)));
        }

    }

    const fastNextPage = () => {
        if (props.TotalPages && props.currentPageNo < props.TotalPages) {
            props.setCurrentPageNo(Math.min(props.TotalPages, props.currentPageNo + ((pageNoArray[pageNoArray.length - 1] - props.currentPageNo)+1)));
        }
    }
    return (
        <>
            <div className=" flex items-center gap-[10px] justify-center">
                {showFastPreviousPage && (
                    <button onClick={fastPreviousPage}>
                        <img src="/images/keyboard_double_arrow_left.svg" />
                    </button>
                )}
                {showPreviousPage && (
                    <button onClick={previousPage} className="bg-[#f6f9ff] rounded-xl p-[4px] border-[#eff0f4] border-[1px]">
                        <TbChevronLeft size={18} />
                    </button>
                )}
                {
                    pageNoArray && pageNoArray.length > 1 && pageNoArray.map((pageNo: number, index: number) => {
                        return (
                            <button onClick={() => selectPage(pageNo)} className={`${props.currentPageNo === pageNo ? "bg-[#7b5aec] text-[#fff]" : " bg-white text-black"} font-sans rounded-xl py-[4px] px-[8px] text-[13px]`} key={`pageNo_${index}`}>
                                {pageNo}
                            </button>
                        )
                    })
                }
                {showNextPage && (
                    <button onClick={nextPage} className="bg-[#f6f9ff] rounded-xl p-[4px] border-[#eff0f4] border-[1px]">
                        <TbChevronRight size={18} />
                    </button>
                )}
                {showFastNextPage && (
                    <button onClick={fastNextPage}>
                        <img src="/images/keyboard_double_arrow_right.svg" />
                    </button>
                )}
            </div>
        </>
    )
}